export default __webpack_public_path__ + "42257130c7b02594b1769896ef05b7d0.svg";